import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage.js';
import { LeaderboardPage } from './pages/LeaderboardPage.js';
import { TeamLeaderboardPage } from './pages/TeamLeaderboardPage.js';
import { IndividualLeaderboardPage } from './pages/IndividualLeaderboardPage.js';

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/:eventId" element={<LeaderboardPage />} />
      <Route path="/:eventId/team" element={<TeamLeaderboardPage />} />
      <Route path="/:eventId/individual" element={<IndividualLeaderboardPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
